import { cloneElement, ReactElement } from 'react'

import { StateCallBack } from '../../../types'

interface LeftArrowProps {
  customLeftArrow?: ReactElement | null
  getState?: () => StateCallBack
  previous: () => void
  disabled?: boolean
}
interface RightArrowProps {
  customRightArrow?: ReactElement | null
  getState?: () => StateCallBack
  next: () => void
  disabled?: boolean
}

const LeftArrow = ({ customLeftArrow, getState, previous, disabled }: LeftArrowProps): ReactElement => {
  if (customLeftArrow && getState) {
    return cloneElement(customLeftArrow, {
      onClick: () => previous(),
      carouselState: getState(),
      disabled: disabled,
    })
  }

  return (
    <button
      aria-label="Previous Blog Card"
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--left"
      onClick={() => previous()}
      type="button"
      disabled={disabled}
    >
      <i className="feather-chevron-left"></i>
    </button>
  )
}
const RightArrow = ({ customRightArrow, getState, next, disabled }: RightArrowProps): ReactElement => {
  if (customRightArrow && getState) {
    return cloneElement(customRightArrow, {
      onClick: () => next(),
      carouselState: getState(),
      disabled: disabled,
    })
  }
  return (
    <button
      aria-label="Next Blog Card"
      className="react-multiple-carousel__arrow react-multiple-carousel__arrow--right"
      onClick={() => next()}
      type="button"
      disabled={disabled}
    >
      <i className="feather-chevron-right"></i>
    </button>
  )
}

export { LeftArrow, RightArrow }
